"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontsStyle = exports.FontsFiles = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var ReactDOM = require("react-dom");
var fonts = [
    {
        name: "hind",
        files: [
            {
                type: "woff",
                url: "https://deepsight-static.s3.amazonaws.com/fonts/hind-semibold-webfont.woff"
            },
            {
                type: "woff2",
                url: "https://deepsight-static.s3.amazonaws.com/fonts/hind-semibold-webfont.woff2"
            }
        ]
    },
    {
        name: "rubik",
        files: [
            {
                type: "woff",
                url: "https://deepsight-static.s3.amazonaws.com/fonts/rubik-regular-webfont.woff"
            },
            {
                type: "woff2",
                url: "https://deepsight-static.s3.amazonaws.com/fonts/rubik-regular-webfont.woff2"
            }
        ]
    }
];
var appendFontToDOM = function (fontName, woff, woff2) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    var Font = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        @font-face {\n            font-family: '", "';\n            font-weight: normal;\n            font-style: normal;\n            src: url('", "') format('woff2'),\n            url('", "') format('woff');\n            font-display: swap\n        }\n    "], ["\n        @font-face {\n            font-family: '", "';\n            font-weight: normal;\n            font-style: normal;\n            src: url('", "') format('woff2'),\n            url('", "') format('woff');\n            font-display: swap\n        }\n    "])), fontName, woff2, woff);
    ReactDOM.render(react_1.default.createElement(Font, null), div);
    div.remove();
};
exports.FontsFiles = function () {
    for (var i = 0; i < fonts.length; i++) {
        appendFontToDOM(fonts[i].name, fonts[i].files[0].url, fonts[i].files[1].url);
    }
};
exports.FontsStyle = styled_components_1.createGlobalStyle(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    @font-face {\n        font-family: '", "';\n        font-weight: normal;\n        font-style: normal;\n        src: url('", "') format('woff2'),\n        url('", "') format('woff');\n        font-display: swap\n    }\n    @font-face {\n        font-family: '", "';\n        font-weight: normal;\n        font-style: normal;\n        src: url('", "') format('woff2'),\n        url('", "') format('woff');\n        font-display: swap\n    }\n"], ["\n    @font-face {\n        font-family: '", "';\n        font-weight: normal;\n        font-style: normal;\n        src: url('", "') format('woff2'),\n        url('", "') format('woff');\n        font-display: swap\n    }\n    @font-face {\n        font-family: '", "';\n        font-weight: normal;\n        font-style: normal;\n        src: url('", "') format('woff2'),\n        url('", "') format('woff');\n        font-display: swap\n    }\n"])), fonts[0].name, fonts[0].files[1].url, fonts[0].files[0].url, fonts[1].name, fonts[1].files[1].url, fonts[1].files[0].url);
var templateObject_1, templateObject_2;
//# sourceMappingURL=fontsFiles.js.map